// @ts-strict-ignore
import { BaseArticlesSequenceOperation } from './base-articles-sequence-operation';
import { IMoveArticlesOperation } from './i-move-articles-operation';
import { ArticleContainer } from '@3d-scene/model3d/article-container';
import { ProjectModel } from '@project/model/project.model';
import { SelectionModel } from '@project/components/article/model/selection.model';
import { Vector3 } from 'three';
import { Dictionary } from 'typescript-collections';
import { ArticleContainerFactory } from '@3d-scene/model3d/article-container.factory';
import { ContainerService } from '@3d-scene/model3d/container.service';
import { ArticleContainerLoader } from '@article/service/article-container-loader';
import { WireBridgeService } from '@project/components/article/manager/wire-bridge.service';
import { InsertArticleUtils } from '@project/components/article/util/insert-article-utils';
import { ProjectArticleService } from '@project/service/project-article.service';
import { SelectionModelService } from '@project/components/article/service/selection-model.service';
import { ProjectMetaElementService } from '@project/manager/project-meta-element.service';
import { ApplicationRefreshService } from '@services/application-refresh.service';
import { DetachArticleUsageService } from '@project/service/detach-article-usage.service';

export class UndoDetachArticlesOperation extends BaseArticlesSequenceOperation implements IMoveArticlesOperation {
  constructor(
    articleContainers: ArticleContainer[],
    projectModel: ProjectModel,
    projectArticleService: ProjectArticleService,
    projectMetaElementService: ProjectMetaElementService,
    selectionModel: SelectionModel,
    selectionModelService: SelectionModelService,
    wireBridgeService: WireBridgeService,
    articleContainerLoader: ArticleContainerLoader,
    articleContainerFactory: ArticleContainerFactory,
    containerService: ContainerService,
    applicationRefreshService: ApplicationRefreshService,
    detachArticleUsageService: DetachArticleUsageService,
    private _insertArticleUtils: InsertArticleUtils,
    private _moveArticlesMap: Dictionary<string, Vector3> = null
  ) {
    super(
      articleContainers,
      projectModel,
      projectArticleService,
      projectMetaElementService,
      selectionModel,
      selectionModelService,
      wireBridgeService,
      articleContainerLoader,
      articleContainerFactory,
      containerService,
      applicationRefreshService,
      detachArticleUsageService
    );
  }

  public getQualifiedClassName(): string {
    return 'UndoDetachArticlesOperation';
  }

  public getOperationDescription(): string {
    return '';
  }


  public async performUndo(): Promise<void> {
    if (this._moveArticlesMap) {
      this._insertArticleUtils.moveArticlesByMap(this._moveArticlesMap, true);
    }
    await this.attachArticles();
  }

  public async performRedo(): Promise<void> {
    await this.detachArticles();
    if (this._moveArticlesMap) {
      this._insertArticleUtils.moveArticlesByMap(this._moveArticlesMap, false);
    }
  }

  public getMoveArticlesMap(): Dictionary<string, Vector3> {
    return this._moveArticlesMap;
  }

  public setMoveArticlesMap(moveMap: Dictionary<string, Vector3>): void {
    this._moveArticlesMap = moveMap;
  }

  public isArticlesOrderChanged(): boolean {
    return false;
  }

  public isDistanceBetweenArticlesChanged(): boolean {
    return true;
  }

  public merge(operation: BaseArticlesSequenceOperation): void {
    super.merge(operation);
    if (operation instanceof UndoDetachArticlesOperation) {
      this.mergeMoveMap(operation.getMoveArticlesMap());
    }
  }

  public mergeMoveMap(moveMap: Dictionary<string, Vector3>): void {
    if (!moveMap) {
      return;
    }

    if (!this._moveArticlesMap) {
      this._moveArticlesMap = new Dictionary<string, Vector3>();
    }
    InsertArticleUtils.mergeMoveMap(this._moveArticlesMap, moveMap);
  }
}
